<template>
  <div class="boss-message-heading">
    <div
      class="boss-message-heading-when"
      data-test="date"
    >
      {{ date | formatDate }}
    </div>
    <div
      class="boss-message-heading-title"
      data-test="status-info"
    >
      選考ステータスを「{{ statusName }}」に変更しました。
    </div>
  </div>
</template>
<script>
import { createDate } from '@/lib/dateUtils.js'

export default {
  filters: {
    formatDate (val) {
      return createDate(val)?.format('YYYY/MM/DD(ddd) HH:mm') ?? ''
    }
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    statusName: {
      type: String,
      default: ''
    }
  }
}
</script>
